var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.vis_data)?_c('div',{ref:"tbGrid"},[_c('highcharts',{staticClass:"bubble-container",attrs:{"options":_vm.bubble_chart_data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }